import React, { useState } from "react";
//outsource
import { Row, Col, Switch } from "antd";

//components

const DialogOff = ({ off, setOff, onChange }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleCheck = (checked) => {
    setOff(checked);
    onChange("off", checked);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <div style={{ width: "100%", textAlign: "right" }}>
      <Switch checked={off} onChange={handleCheck} />
      <span style={{ marginLeft: 5 }}>Off</span>
    </div>
  );
};

export default DialogOff;
